import * as React from 'react';
import ErrorText from "../../atom/text/error_text";
import styled from "styled-components";
import {ConstBorderRound, ConstColor, ConstFontStyle} from "../../../../config/styles_const/styles_const";
import FormRadioButton from "../../atom/form/form_radio_button";

interface IProps {
    name: string;
    label: string;
    type: string;
    hasError: boolean;
    errorText: string;
    input?: any;
}

const FormGroupRadioButton: React.FC<IProps> = (props) => {

    const { type, label, hasError, errorText, input} = props;

    return (
        <Wrapper>
            <FormRadioButton
                id={input.value}
                {...input}
                type={type}
                hasError={hasError}
            />
            <RadioButtonLabel htmlFor={input.value} >
                <RadioButtonLabelText>
                    {label}
                </RadioButtonLabelText>
            </RadioButtonLabel>
            {hasError &&
            <ErrorText>{errorText}</ErrorText>
            }
        </Wrapper>
    );
};

export default (FormGroupRadioButton);

const height = "26px";

const RadioButtonLabelText = styled.span`
    display: inline-block;
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${ConstFontStyle.LabelDefault.fontWeight};
    font-size: ${ConstFontStyle.LabelDefault.fontSize};
    line-height: ${ConstFontStyle.LabelDefault.lineHeight};
    margin-bottom: 0;
    height: ${ConstFontStyle.LabelDefault.lineHeight};
    & a {
        color: ${ConstColor.Corporate};
    }
`;

const RadioButtonLabel = styled.label`
`;

const Wrapper = styled.div`
    min-height: ${height}; // checkboxの大きさ指定しておきlabel文字をvertical-align: middle;で上下余白をコントロールする
    position: relative;
    & ${FormRadioButton}{
        // 元のcheckboxをdisplay: none;のみで消すとtabが聞かずfocusができないための処理
        /* 透明度0 */
        opacity:0;
        /* ブラウザのデフォルトのスタイルを削除 */
        appearance: none;
        /* レイアウトから無視 */
        position: absolute;
    }
    & ${RadioButtonLabel}{
        padding-left: 36px;
        position:relative;
        height: ${height};
        display: flex;
        align-items: center;
    }
    & ${RadioButtonLabel}::before{
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: ${height};
        height: ${height};
        border: 1px solid ${ConstColor.Gray};
        border-radius: ${ConstBorderRound.CornerRoundAll};
    }
    & ${FormRadioButton}:focus + ${RadioButtonLabel}::before{
        border: 1px solid ${ConstColor.Focus};
    }
    & ${FormRadioButton}:checked + ${RadioButtonLabel}::before{
        border: 1px solid ${ConstColor.PlaceholderAndBorder};
    }
    & ${FormRadioButton}:checked + ${RadioButtonLabel}::after{
        content: "";
        display: block;
        position: absolute;
        top: 6px;
        left: 6px;
        width: 13px;
        height: 7px;
        transform: rotate(-45deg);
        border-bottom: 3px solid ${ConstColor.Corporate};
        border-left: 3px solid ${ConstColor.Corporate};
    }  
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_radio_button.tsx